export enum OttokartCustomerEngagementWorkspaceCapabilityAccessOperation {
    create = "c1d2e3f4-a5b6-4789-a012-3456789abc01",
    read = "c1d2e3f4-a5b6-4789-b012-3456789abc02",
    update = "c1d2e3f4-a5b6-4789-a012-3456789abc03",
    delete = "c1d2e3f4-a5b6-4789-b012-3456789abc04",
}
